export default __webpack_public_path__ + "static/media/008-sailor-cap-1.9e3060c1.png";